export default __webpack_public_path__ + "static/media/background.4cb3aff0.jpg";